import { Component } from "react";

import "./Badge.scss";

export default class Badge extends Component {
  render() {
    let numeric_style = "badge";
    if (this.props.className) {
      numeric_style = this.props.className + " badge";
    }

    if (!this.props.count || this.props.count === 0) {
      numeric_style = "hidden";
    }

    let notice_style = "notification";
    if (this.props.className) {
      notice_style = this.props.className + " notification";
    }

    if (this.props.notice === undefined) {
      notice_style = "hidden";
    }

    return (
      <div>
        {numeric_style && (
          <div className={numeric_style}>
            <span>{this.props.count}</span>
          </div>
        )}
        {notice_style && (
          <div className={notice_style}>
            <span>{this.props.notice}</span>
          </div>
        )}
      </div>
    );
  }
}
